import { pageSizes, pickerOptions } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import { setToday } from '@/utils/filter';

export default {
  name: 'wait-fee',
  mixins: [pageSize],
  data() {
    return {
      options: [], // 所有诊所
      clinic: [], // 选中诊所
      pageSizes,
      pickerOptions,
      streamInfo: {},
      tableData: [],
      total: 0, // 总数据条数
      time: [],
      query: {
        hospitalIdList: [], // 诊所id
        startTime: '',
        endTime: '',
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
      },
      doctorOptions: [{
        doctorId: null,
        realName: '全部',
      }],
      chartData: {
        columns: ['日期', '就诊人数', '总营业额', '药品利润'],
        rows: [],
      },
    };
  },
  methods: {
    
    // 按地区查询连锁诊所此账号下所有诊所信息
    getClinicByArea() {
      this.$api.chainManageStatistics.area().then((res) => {
        console.log(res);
        this.options = res;
      });
    },
    // 查询连锁诊所此账号下所有诊所信息
    getClinic() {
      this.$api.chainManageStatistics.hospitals({
        hospitalName: '',
      }).then((res) => {
        console.log(res);
        // this.options = res;
      });
    },
    // 获取图表数据
    getChart() {
      this.$api.chainManageStatistics.chart({
        ...this.query,
      }).then((res) => {
        console.log(res);
        this.streamInfo = res;
        this.chartData.rows = res.chartDataList.map(item => ({
          '日期': item.time,
          '就诊人数': item.visits,
          '总营业额': item.totalSum,
          '药品利润': item.profit,
        }));
      });
    },
    getDataByClinic() {
      if (this.query.hospitalIdList.length === this.hospitalIdList.length) return;
      this.getTableData(1);
    },
    // 获取列表信息
    getTableData(type) {
      if (type === 1) this.query.currentPage = 1;
      this.query.hospitalIdList = this.hospitalIdList;
      this.query.startTime = this.time ? this.time[0] : '';
      this.query.endTime = this.time ? this.time[1] : '';
      // this.getChart();
      this.$api.chainManageStatistics.operations(this.query).then((res) => {
        console.log(res);
        this.streamInfo = res.totalStatistic;
        this.chartData.rows = res.totalStatistic.chartDataList.map(item => ({
          '日期': item.time,
          '就诊人数': item.visits,
          '总营业额': item.totalSum,
          '药品利润': item.profit,
        }));
        this.tableData = res.orderStatisticList;
        this.total = res.totalSize || 0;
      });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getTableData(1);
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.currentPage = val;
      this.getTableData();
    },
  },
  mounted() {
    this.time = setToday(); // 设置默认日期
    this.getClinicByArea();
  },
  computed: {
    // 筛选出来的诊所
    hospitalIdList() {
      return this.clinic.map(item => item[2]);
    },
  },
};
